document.addEventListener('DOMContentLoaded', () => {
  const btn = document.querySelector('.js-size-redirect');
  if (!btn) return;

  const MAX_TRIES = 60;
  let tries = 0;

  const findFavoriteButton = () => {
    return (
      document.querySelector('.swym-button-bar') ||
      document.querySelector('.swym-wishlist-button-bar') ||
      document.querySelector('[data-swaction="addToWishlist"]') ||
      document.querySelector('.product__wishlist') ||
      null
    );
  };

  const placeButton = () => {
    const favoriteBtn = findFavoriteButton();
    const widget = document.querySelector('#szb-container');

    if (favoriteBtn && favoriteBtn.parentNode) {
      favoriteBtn.parentNode.insertBefore(btn, favoriteBtn);
      return true;
    }

    if (widget) {
      widget.after(btn);
      return true;
    }
    return false;
  };

  setTimeout(() => {
    const timer = setInterval(() => {
      if (placeButton() || ++tries >= MAX_TRIES) {
        btn.classList.add('is-visible');
        clearInterval(timer);
      }
    }, 50);
  }, 1000);
});